<template>
  <tr :class="classes" v-bind="$attrs">
    <slot />
  </tr>
</template>

<script setup lang="ts">
import { computed, toRefs } from "vue";

export interface TrProps {
  tableTarget?: "thead" | "tbody";
  zebra?: boolean;
  className?: Record<string, boolean> | string[] | string;
  active?: boolean;
}

const props = withDefaults(defineProps<TrProps>(), {
  tableTarget: "tbody",
  zebra: false,
  className: undefined,
  active: false,
});

const defaultStyles = {
  thead: "",
  tbody:
    "tw-border-b tw-border-dorian-gray-100/80 tw-h-9 hover:tw-bg-secondary-50 dark:hover:tw-bg-dorian-gray-100",
};

const { className, zebra, tableTarget, active } = toRefs(props);

const classes = computed(() => {
  const getBackgroundClass = () => {
    if (active.value) {
      return "tw-bg-secondary-200";
    }
    if (zebra.value) {
      return "tw-bg-light";
    }
    return "tw-bg-white";
  };

  const bg = getBackgroundClass();

  return [defaultStyles[tableTarget.value], bg, className.value];
});
</script>
